import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';

@Injectable({
  providedIn: 'root'
})
export class PermissionsListenerService {

  auditLogPermissions = {
    isAuditForPermissions: true,
    permission_create_success: true,
    permission_create_failed: true,
    permissiongroup_create_success: true,
    permissiongroup_create_failed: true,
    permissiongroup_associatetorole_success: true,
    permissiongroup_associatetorole_failed: true,
  };

  @Output() permissionsListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.permissionsListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        }
    );
  }
}
